import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import RequestAccess from "@/pages/RequestAccess";
import SampleBoard from "@/pages/SampleBoard";
import SampleBoardChooser from "@/pages/SampleBoardChooser";
import Login from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import TrackDelivery from "@/pages/TrackDelivery";
import Today from "@/pages/Today";
import MyQueue from "@/pages/MyQueue";
import ShipmentBoard from "@/pages/ShipmentBoard";
import NeedsAttention from "@/pages/NeedsAttention";
import ShipmentDetail from "@/pages/ShipmentDetail";
import Documents from "@/pages/Documents";
import CustomerUpdates from "@/pages/CustomerUpdates";
import Customers from "@/pages/Customers";
import CustomerProfile from "@/pages/CustomerProfile";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import AdminConsole from "@/pages/AdminConsole";
import Billing from "@/pages/Billing";
import InterIslandPorts from "@/pages/InterIslandPorts";
import ComingSoon from "@/pages/ComingSoon";
import { useMobileFocusScroll } from "@/hooks/useMobileFocusScroll";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

function App() {
  useMobileFocusScroll();
  return (
    <AuthProvider>
      <WorkspaceProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/request-access" element={<RequestAccess />} />
          <Route path="/sample-board" element={<SampleBoardChooser />} />
          <Route path="/sample-board/caribbean" element={<SampleBoard region="caribbean" />} />
          <Route path="/sample-board/overland" element={<SampleBoard region="overland" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/track/:token" element={<TrackDelivery />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/app/today" element={<ProtectedRoute><Today /></ProtectedRoute>} />
          <Route path="/app/my-queue" element={<ProtectedRoute><MyQueue /></ProtectedRoute>} />
          <Route path="/app/board" element={<ProtectedRoute><ShipmentBoard /></ProtectedRoute>} />
          <Route path="/app/needs-attention" element={<ProtectedRoute><NeedsAttention /></ProtectedRoute>} />
          <Route path="/app/shipments/:id" element={<ProtectedRoute><ShipmentDetail /></ProtectedRoute>} />
          <Route path="/app/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
          <Route path="/app/customer-updates" element={<ProtectedRoute><CustomerUpdates /></ProtectedRoute>} />
          <Route path="/app/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
          <Route path="/app/customers/:id" element={<ProtectedRoute><CustomerProfile /></ProtectedRoute>} />
          <Route path="/app/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/app/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/app/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
          <Route path="/app/inter-island" element={<ProtectedRoute><InterIslandPorts /></ProtectedRoute>} />
          <Route path="/app/admin" element={<ProtectedRoute><AdminConsole /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" />
        </BrowserRouter>
      </WorkspaceProvider>
    </AuthProvider>
  );
}

export default App;
